import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function Newsletter() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await api.post("/newsletter", { email });
            toast.success("You're in. Welcome to the MyStreetz drop.");
            setEmail("");
        } catch (err) {
            toast.error("Couldn't subscribe. Try a valid email.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section
            data-testid="newsletter-section"
            className="bg-streetz-paper border border-streetz-line p-6 md:p-8 flex flex-col gap-4"
        >
            <div className="overline text-streetz-yellow">STAY IN THE LOOP</div>
            <h3 className="font-display uppercase text-2xl md:text-3xl text-white tracking-tight leading-none">
                Get the latest music, videos, news & street updates.
            </h3>
            <form onSubmit={onSubmit} className="flex flex-col gap-3 mt-2">
                <input
                    type="email"
                    required
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="newsletter-email-input"
                    className="bg-black border border-streetz-line px-4 py-3 text-white placeholder:text-streetz-muted focus:border-streetz-red focus:outline-none"
                />
                <button
                    disabled={loading}
                    data-testid="newsletter-subscribe-button"
                    className="bg-streetz-red text-white overline py-3 inline-flex items-center justify-center gap-2 hover:bg-white hover:text-black transition-colors disabled:opacity-60"
                >
                    {loading ? "SUBSCRIBING..." : (<>SUBSCRIBE NOW <Send className="w-4 h-4" /></>)}
                </button>
                <p className="text-xs text-streetz-muted text-center">
                    No spam. Unsubscribe anytime.
                </p>
            </form>
        </section>
    );
}
